// import { IResourceComponentsProps } from "@refinedev/core";
// import { MuiShowInferencer } from "@refinedev/inferencer/mui";

// export const FarmerShow: React.FC<IResourceComponentsProps> = () => {
//   return (
//     <MuiShowInferencer
//       fieldTransformer={(field: any) => {
//         if (["locale", "updatedAt", "publishedAt"].includes(field.key)) {
//           return false;
//         }

//         return field;
//       }}
//     />
//   );
// };
import { Alert, Button, Snackbar, Stack, Typography } from "@mui/material";
import { useShow } from "@refinedev/core";
import { Show, TextFieldComponent as TextField } from "@refinedev/mui";
import TransactionsTable from "components/actions/Transactions";
import { useState } from "react";
import { useMutation } from "react-query";
import { updateOut } from "services/out";

export const FarmerShow = () => {
  const [showIns, setShowIns] = useState(false);
  const [showArchivedOuts, setShowArchivedOuts] = useState(false);
  const { queryResult } = useShow({
    liveMode: "auto",
    meta: {
      populate: "*",
    },
  });
  const { data, isLoading } = queryResult;

  const record = data?.data;

  const mutation = useMutation(updateOut, {
    onSuccess: () => {
      queryResult.refetch();
    },
  });

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
  };

  return (
    <Show isLoading={isLoading}>
      <Stack gap={1} mb={2}>
        <Stack direction="row" alignItems="center" justifyContent="end">
          <Button onClick={() => setShowIns(!showIns)}>
            {!showIns ? "Show Ins" : "Hide Ins"}
          </Button>
          <Button onClick={() => setShowArchivedOuts(!showArchivedOuts)}>
            {!showArchivedOuts ? "Show Archive" : "Hide Archive"}
          </Button>
        </Stack>
        <Snackbar
          open={mutation.isSuccess}
          autoHideDuration={6000}
          onClose={handleClose}
        >
          <Alert
            onClose={handleClose}
            severity="success"
            sx={{ width: "100%" }}
          >
            Out archived with success!
          </Alert>
        </Snackbar>

        <Stack gap={1}>
          <Typography variant="body1" fontWeight="bold">
            Name
          </Typography>
          <TextField value={record?.name} />
          <Typography variant="body1" fontWeight="bold">
            Phone
          </Typography>
          <TextField value={record?.phone ? "(+216) " + record?.phone : ""} />
        </Stack>
      </Stack>

      <TransactionsTable transactions={record?.actions || []} />
    </Show>
  );
};
